__turbopack_context__.v({
  "inner": "modal-module__ty5aEG__inner",
  "modal": "modal-module__ty5aEG__modal",
});
